import styled from 'styled-components';

export const StyledNetWorthTable = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #444;
  background: #fff;

  > *:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: none;
  }
`;

export const NetWorthTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  background: #E5E7EB;
  font-weight: 600;
`;

export const NetWorthTableRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NetWorthTableLabelCell = styled.div`
  flex: 1;
  padding: 12px 16px;
  font-weight: 400;
  text-align: left;
`;

export const NetWorthTableValueCell = styled.div`
  padding: 12px 16px;
  font-weight: 400;
  text-align: right;
`;

export const NetWorthTableGroupHeader = styled.div<{ color: string }>`
  padding: 12px 16px 12px 44px;
  text-align: left;
  font-weight: 600;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background: #F4F5F7;

  &::before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 2px;
    background: ${({ color }) => color};
    display: block;
    position: absolute;
    margin-top: 2px;
    margin-left: -28px;
  }
`;
